import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, Hand } from "lucide-react";

const KEY = "sh_swipe_hint_seen";

function useHint(show) {
  const [hint, setHint] = useState(false);
  useEffect(() => {
    if (!show || localStorage.getItem(KEY)) return;
    const a = setTimeout(() => setHint(true), 1200);
    const b = setTimeout(() => { setHint(false); localStorage.setItem(KEY, "1"); }, 6200);
    return () => { clearTimeout(a); clearTimeout(b); };
  }, [show]);
  const dismiss = () => { setHint(false); localStorage.setItem(KEY, "1"); };
  return [hint, dismiss];
}

export function RoomSwiper({ rooms, activeId, onSelect }) {
  const [idx, setIdx] = useState(0);
  const start = useRef(null);
  const [hint, dismiss] = useHint(rooms.length > 1);
  if (rooms.length < 2) return null;
  const found = rooms.findIndex((r) => r.id === activeId);
  const cur = found >= 0 ? found : idx;
  const go = (d) => {
    dismiss();
    const n = (cur + d + rooms.length) % rooms.length;
    setIdx(n);
    onSelect(rooms[n]);
  };
  const onEnd = (e) => {
    if (start.current == null) return;
    const dx = e.changedTouches[0].clientX - start.current;
    start.current = null;
    if (Math.abs(dx) > 30) go(dx < 0 ? 1 : -1);
  };
  return (
    <div className="relative">
      {hint && (
        <div className="absolute bottom-full left-0 mb-2 animate-in fade-in slide-in-from-bottom-2 duration-300" data-testid="room-swipe-hint">
          <div className="rounded-2xl bg-white text-slate-900 shadow-2xl px-3 py-2 text-xs font-semibold inline-flex items-center gap-2 whitespace-nowrap">
            <Hand className="w-4 h-4 sh-swipe-hand" />Swipe to change rooms
          </div>
          <span className="block w-3 h-3 bg-white rotate-45 -mt-1.5 ml-6" />
        </div>
      )}
    <div onTouchStart={(e) => { start.current = e.touches[0].clientX; }} onTouchEnd={onEnd}
      className={`h-12 rounded-full glass-dark flex items-center gap-1 px-1 select-none touch-pan-y ${hint ? "sh-swipe-nudge ring-2 ring-white/70" : ""}`} data-testid="room-swiper">
      <button onClick={() => go(-1)} className="w-10 h-10 rounded-full grid place-items-center hover:bg-white/10 shrink-0" aria-label="Previous room" data-testid="room-swiper-prev"><ChevronLeft className="w-5 h-5" /></button>
      <div className="min-w-0 flex-1 text-center leading-tight">
        <p className="truncate text-sm font-semibold" data-testid="room-swiper-name">{rooms[cur].title}</p>
        <p className="text-[10px] text-white/50">{cur + 1} / {rooms.length} · swipe</p>
      </div>
      <button onClick={() => go(1)} className="w-10 h-10 rounded-full grid place-items-center hover:bg-white/10 shrink-0" aria-label="Next room" data-testid="room-swiper-next"><ChevronRight className="w-5 h-5" /></button>
    </div>
    </div>
  );
}
